import styled from 'styled-components';

interface IProps {
    className?: string;
}

const BaseCirclePlus = ({ className }: IProps) => (
    <svg
        className={className}
        fill="none"
        version="1.1"
        viewBox="0 0 24 24"
        xmlns="http://www.w3.org/2000/svg"
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <circle cx="12" cy="12" r="11" stroke="black" strokeWidth="2" />
        <path
            d="M17.5135 11.0811H12.9189V6.48648H11.0811V11.0811H6.48649V12.9189H11.0811V17.5135H12.9189V12.9189H17.5135V11.0811Z"
            fill="black"
        />
    </svg>
);

export const CirclePlus = styled(BaseCirclePlus)``;
